<template>
  <v-container>
    <h1>Page Not Found</h1>
    <h3>Requested URL: {{ url }}</h3>
    <h3>Please, go back to  <v-btn to="/">Home</v-btn></h3>
  </v-container>
</template>

<script>
export default {
    name: 'PageNotFound',
    data() {
        return {
            url: window.location.pathname
        }
    }
}
</script>